import { Injectable, Inject } from '@angular/core';
import { Subject, Observable, throwError } from 'rxjs';
import { catchError, map, timeout } from 'rxjs/operators';

import { ApiCommonService } from 'cbc-shared-lib';

import { FEATURES_LIB_CONFIG } from '../../../../../config/features-lib-config.token';
import { FeaturesLibConfig } from '../../../../../config/features-lib-config';

import {
  Sgkd030aService,
  Sgkd030aRequest,
  Sgkd030aResponse
} from 'sg-api';

@Injectable({
  providedIn: 'root'
})
export class UsedSgkd010dSgkd030aService {

  private _rsesult$ = new Subject<Sgkd030aResponse>();

  constructor(
    private sgkd030aService: Sgkd030aService,
    private apiCommonService: ApiCommonService,
    @Inject(FEATURES_LIB_CONFIG) private featuresLibConfig: FeaturesLibConfig) { }

  /**
   * 口座振替依頼返却情報一覧取得API呼び出し
   * @param frikaedate 口座振替日
   * @param reqretDeadline 依頼返却締切日
   * @param reqretFinancialinstitutioncode 依頼返却金融機関コード
   * @param outputfinishRequestreturndisplayFlg 出力済依頼返却表示フラグ
   * @memberof UsedSgkd010dSgkd030aService
   */
  select(frikaedate: string, reqretDeadline: string, reqretFinancialinstitutioncode: string,
    outputfinishRequestreturndisplayFlg: string): Observable<Sgkd030aResponse> {

    // リクエスト生成
    let request: Sgkd030aRequest = {
      requestDto: {
        frikaedate: frikaedate,
        reqretDeadline: reqretDeadline,
        reqretFinancialinstitutioncode: reqretFinancialinstitutioncode,
        outputfinishRequestreturndisplayFlg: outputfinishRequestreturndisplayFlg
      }
    };

    return this.sgkd030aService.doSGKD030APost(this.apiCommonService.setRequestCommon(request), 'response')
      // NOTE:component側に戻り値として値を返却したい場合は、pipe(map())処理内で値を返却する。
      .pipe(
        map(response => {
          // エラーが設定されていないかチェックする
          this.apiCommonService.checkError(response);
          this._rsesult$.next(response.body);
          return response.body;
        }),
        timeout(Number(this.featuresLibConfig.httpTimeout)),
        catchError((err) => {
          this.apiCommonService.dispErrorMessage(err, 'bill', 'SGKD030A');
          return throwError(err.message);
        }
      )
    );
  }
}
